'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _publicPageUrls = require('pricing-pages-unified-ui/utils/publicPageUrls');

var _nonMerchandiseIdProductPropInterface = require('pricing-pages-unified-ui/utils/nonMerchandiseIdProductPropInterface');

var _nonMerchandiseIdProductPropInterface2 = _interopRequireDefault(_nonMerchandiseIdProductPropInterface);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _partial = require('transmute/partial');

var _partial2 = _interopRequireDefault(_partial);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackClick = function trackClick(_ref) {
  var sourceId = _ref.sourceId,
      merchandiseId = _ref.merchandiseId,
      nonMerchandiseIdProduct = _ref.nonMerchandiseIdProduct,
      hubsSignupUrl = _ref.hubsSignupUrl,
      hubsSignupCta = _ref.hubsSignupCta;

  (0, _getUsageTracker2.default)().track('talkToSales', {
    sourceId: sourceId,
    merchandiseId: merchandiseId,
    nonMerchandiseIdProduct: nonMerchandiseIdProduct,
    hubsSignupCta: hubsSignupCta,
    hubsSignupUrl: hubsSignupUrl
  });
};

var TalkToSalesButton = function TalkToSalesButton(_ref2) {
  var sourceId = _ref2.sourceId,
      merchandiseId = _ref2.merchandiseId,
      use = _ref2.use,
      className = _ref2.className,
      nonMerchandiseIdProduct = _ref2.nonMerchandiseIdProduct;

  var hubsSignupCta = (0, _publicPageUrls.getHubsSignupCTA)('tts', sourceId, merchandiseId, nonMerchandiseIdProduct);
  var gaClassName = (0, _publicPageUrls.getGAClassName)(hubsSignupCta);
  var hubsSignupUrl = (0, _publicPageUrls.getHubsSignupUrl)({
    merchandiseId: merchandiseId,
    nonMerchandiseIdProduct: nonMerchandiseIdProduct
  });

  var HREF = (0, _publicPageUrls.getTtsUrl)() + '?hubs_signup-url=' + hubsSignupUrl + '&hubs_signup-cta=' + hubsSignupCta;

  return _react2.default.createElement(
    _UIButton2.default,
    {
      use: use,
      href: HREF,
      className: gaClassName + ' ' + className,
      target: '_blank',
      onClick: (0, _partial2.default)(trackClick, {
        sourceId: sourceId,
        merchandiseId: merchandiseId,
        nonMerchandiseIdProduct: nonMerchandiseIdProduct,
        hubsSignupUrl: hubsSignupUrl,
        hubsSignupCta: hubsSignupCta
      })
    },
    _react2.default.createElement(_FormattedMessage2.default, {
      message: 'pricingPage.pricingCtas.talkToSales',
      className: gaClassName
    })
  );
};

TalkToSalesButton.propTypes = _extends({
  sourceId: _react.PropTypes.string.isRequired,
  merchandiseId: _react.PropTypes.number,
  use: _react.PropTypes.string.isRequired,
  className: _react.PropTypes.string
}, _nonMerchandiseIdProductPropInterface2.default);

TalkToSalesButton.defaultProps = {
  use: 'primary'
};

exports.default = TalkToSalesButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/public-only/TalkToSalesButton.js
// module id = 715
// module chunks = 3 4